<p-card styleClass="very-compact-card p-3">
  <h3 class="mb-3">Аренда</h3>

  <div class="p-fluid">
    <div class="field">
      <label class="font-medium">Дата начала аренды</label>
      <crm-datepicker
        [(value)]="deal.rentStartDate"
        [inputStyleClass]="errors?.rentStartDate ? 'ng-invalid ng-dirty' : ''"
        appendTo="body"></crm-datepicker>
      @if (errors?.rentStartDate) {
        <small class="p-error">
          {{ errors.rentStartDate | join }}
        </small>
      }
    </div>

    <div class="field">
      <label class="font-medium">Помещение</label>
      <crm-room-multi-select
        [(selectedRooms)]="deal.rentRooms"
        [isFloatLabel]="false"
        [isError]="$any(errors?.rentRooms)"
        appendTo="body"></crm-room-multi-select>
      @if (errors?.rentRooms) {
        <small class="p-error">
          {{ errors.rentRooms | join }}
        </small>
      }

      @if (deal.rentRooms?.length) {
        <div>
          @for (room of deal.rentRooms; track room.id; let isLast = $last) {
            <span>{{ room.name }} ({{ room.floor ? room.floor + ' этаж' : 'Без этажа' }})</span
            ><span *ngIf="!isLast">, </span>
          }
        </div>
        <p>Общая площадь: {{ (deal.rentRooms | sum: 'square') || 0 }} м<sup>2</sup></p>
      }
    </div>

    <div class="field">
      <label class="font-medium">Коридорный коэффициент</label>
      <p-inputNumber
        [(ngModel)]="deal.rentCorridorFactor"
        [minFractionDigits]="2"
        [ngClass]="{ 'ng-invalid ng-dirty': errors?.rentCorridorFactor }"></p-inputNumber>
      @if (errors?.rentCorridorFactor) {
        <small class="p-error">
          {{ errors.rentCorridorFactor | join }}
        </small>
      }
    </div>

    <div class="field">
      <label class="font-medium">Арендная плата</label>
      <p-inputNumber
        [(ngModel)]="deal.rentAmount"
        [min]="0"
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
        [ngClass]="{ 'ng-invalid ng-dirty': errors?.rentAmount }"></p-inputNumber>
      @if (errors?.rentAmount) {
        <small class="p-error">
          {{ errors.rentAmount | join }}
        </small>
      }
    </div>

    <div class="field">
      <label class="font-medium">Обеспечительный взнос</label>
      <p-inputNumber
        [(ngModel)]="deal.rentSecurityDeposit"
        [ngClass]="{ 'ng-invalid ng-dirty': errors?.rentSecurityDeposit }"></p-inputNumber>
      @if (errors?.rentSecurityDeposit) {
        <small class="p-error">
          {{ errors.rentSecurityDeposit | join }}
        </small>
      }
    </div>

    <div class="field">
      <label class="font-medium">Стоимость парковочного места</label>
      <p-inputNumber
        [(ngModel)]="deal.rentParkingLotPrice"
        [ngClass]="{ 'ng-invalid ng-dirty': errors?.rentParkingLotPrice }"></p-inputNumber>
      @if (errors?.rentParkingLotPrice) {
        <small class="p-error">
          {{ errors.rentParkingLotPrice | join }}
        </small>
      }
    </div>
  </div>
</p-card>
